import React, { useEffect, useState } from "react";

/**Import Styles and Assets */
import styles from "./index.module.scss";
import { ReactComponent as Back } from "./images/back.svg"

import { usePostReportListingHeader, usePostReportUserListing } from "../../schemas/tableHeaderSchema";
import TableLayout from "../../components/TableLayout";
import { useDispatch, useSelector } from "react-redux";
import { fetchPostReportThunk } from "../../features/PostReportReducer";
import FileReaderModal from "../../components/Modal/FileReaderModal";



export default function PostReport() {

    const { data, status } = useSelector(state => state.postReport);
    const { search } = useSelector(state => state.search);
    const [list, setList] = useState(data);
    const dispatch = useDispatch();

    const [isListed, setIsListed] = useState(true);
    const [postReportList, setPostReportList] = useState([])
    const [reportList, setReportList] = useState(postReportList);
    const [file, setFile] = useState({
        path: "",
        type: ""
    });

    const userReportHeader = usePostReportUserListing(setIsListed, setPostReportList);
    const listingHeader = usePostReportListingHeader(setIsListed, setPostReportList, setFile);

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchPostReportThunk());
        }
    }, [])

    useEffect(() => {
        if (!search) return setList(data);
        if (!isListed) return

        const array = [
            ...data.map(item => {
                if (item.owner_name.toLowerCase().includes(search.toLowerCase())) {
                    return item
                }
            })
        ].filter(Boolean)
        setList(array);

    }, [data, search])

    useEffect(() => {
        if (!search) return setReportList(postReportList);
        if (isListed) return

        const array = [
            ...postReportList.map(item => {
                if (item.user_name.toLowerCase().includes(search.toLowerCase())) {
                    return item
                }
            })
        ].filter(Boolean)
        setReportList(array);

    }, [search, postReportList])


    function handleClose() {
        setFile({
            path: "",
            type: "",
        })
    }


    return isListed ?
        <div className={styles.postReport} >
            <h1 className={styles.contentTitle}>Post Reports</h1>
            <div className={styles.content}>
                {file.path ? <FileReaderModal {...{ ...file, handleClose }} /> : ""}
                <TableLayout headers={listingHeader} data={list} status={status} />
            </div>
        </div > :
        <div className={styles.postReport} >
            <div onClick={() => setIsListed(true)} className={styles.backButton}>
                <Back />
                <h1 className={styles.backButton} >Back</h1>
            </div>
            <div className={styles.content}>
                <TableLayout headers={userReportHeader} data={reportList} status={"success"} />
            </div>
        </div >





}